<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.Configuration'
}
</script>

<style scoped>

</style>
